export default {
    'account-info': 'Account Information',
    save: 'Save',
    cancel: 'Cancel',
    'account-name': 'Account name',
    'main-account': 'Main account',
    "pinned": "Pinned",
    "pinned-description": "Pinned accounts will be displayed on the home page",
    'account-type': {
        title: 'Account type',
        main: 'Main account',
        sub: 'Sub account',
    },
    
    'final-accounts': {
        title: 'Final Account',
        operations: 'Operating',
        trade: 'Trading',
        'gains-and-losses': 'Profit and losses',
        budget: 'Balance sheet',
    },

    'custom-statement': 'Customised statement',
    'max-debit-amount': 'Debit limit',
    'max-credit-amount': 'Credit Limit',
    'debt-is-forbidden': 'Banned From Debt',
    'notes': 'Notes',
    'contect-info': {
        title: 'Contact information',
        'mobile-number': 'Mobile number',
        'phone-number': 'Phone number',
        email: 'Email',
        address: 'Address',
    },

    'edit-account': 'Edit account',
    'create-account': 'Create account',
}